import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/rscu/pages/CalculatorPage";

export const Route = createFileRoute("/rscu")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/rscu",
      title: m.rscu_meta_title(),
      description: m.rscu_meta_description(),
      toolName: m.rscu_tool_name(),
      faqs: [
        { q: m.rscu_faq_q1(), a: m.rscu_faq_a1() },
        { q: m.rscu_faq_q2(), a: m.rscu_faq_a2() },
        { q: m.rscu_faq_q3(), a: m.rscu_faq_a3() },
        { q: m.rscu_faq_q4(), a: m.rscu_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
